export default class AppShare {
  constructor(container, options) {
    const defaultOptions = {
    }

    this.options = Object.assign({}, defaultOptions, options)
    this.container = document.querySelector(container)
    this.facebookButton = this.container.querySelector('.icon-container.facebook')
    this.linkedInButton = this.container.querySelector('.icon-container.linkedin')
    this.twitterButton = this.container.querySelector('.icon-container.twitter')
    this.pageUrl = document.URL
    this.metaTitle = this.container.dataset.title // this might be different when dynamic meta title is set

    if (this.facebookButton !== null) {
      this.facebookButton.addEventListener('click', this.onClickFacebookButton.bind(this))
    }

    if (this.linkedInButton !== null) {
      this.linkedInButton.addEventListener('click', this.onClickLinkedInButton.bind(this))
    }

    if (this.twitterButton !== null) {
      this.twitterButton.addEventListener('click', this.onClickTwitterButton.bind(this))
    }
  }

  onClickFacebookButton() {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.pageUrl)}&amp;quote=${encodeURIComponent(this.pageUrl)}`
    window.open(facebookUrl, '_blank')
  }

  onClickLinkedInButton() {
    const linkedInURL = `http://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.pageUrl)}&title=${encodeURIComponent(this.metaTitle)}`
    window.open(linkedInURL, '_blank')
  }

  onClickTwitterButton() {
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(this.metaTitle)}:%20${encodeURIComponent(this.pageUrl)}`
    window.open(twitterUrl, '_blank')
  }
}